import type { EntityTypeFilter, ActionFilter } from "../types/auditoria.types";

export const AUDIT_API_ENDPOINTS = {
  AUDIT: "/internal/operations/audit",
  PAYMENT_AUDIT: "/internal/operations/audit/payments",
  PAYMENT_AUDIT_EXPORT: "/internal/operations/audit/payments/export",
  CLIENTS_SEARCH: "/internal/operations/audit/clients-search",
  ORGANIZATION_BY_EMAIL: "/internal/clients/organizations/by-email",
  CLIENT_BY_EMAIL: "/internal/clients/by-email",
  entityHistory: (type: string, id: string): string =>
    `/internal/operations/audit/entity/${encodeURIComponent(type)}/${encodeURIComponent(id)}`,
} as const;

export const AUDITORIA_PAGE_SIZE = 25;

/**
 * Mirrors `PAYMENT_AUDIT_EXPORT_ROW_LIMIT` in coloca-nest. Used only to word the refusal: the cap is enforced
 * by the backend, which answers 400 rather than a partial report, so a stale value here can misquote the
 * limit but never let an over-cap export through.
 */
export const PAYMENT_AUDIT_EXPORT_MAX_ROWS = 5000;

export const FLUJO_OPTIONS: { value: EntityTypeFilter; label: string }[] = [
  { value: "NOTE", label: "Nota" },
  { value: "PAYMENT_CONFIRMATION", label: "Confirmación de pago" },
  { value: "PAYMENT", label: "Pago" },
];

export const ACCION_OPTIONS: { value: ActionFilter; label: string }[] = [
  { value: "UPDATE", label: "Actualización de datos" },
  { value: "STATUS_CHANGE", label: "Cambio de estado" },
  { value: "CREATE", label: "Creación" },
  { value: "DELETE", label: "Eliminación" },
];

const NOTE_ACCION_VALUES: ActionFilter[] = ["CREATE", "DELETE"];

export function getAccionOptions(flujo: EntityTypeFilter | ""): { value: ActionFilter; label: string }[] {
  if (flujo === "NOTE") {
    return ACCION_OPTIONS.filter((o) => NOTE_ACCION_VALUES.includes(o.value));
  }
  return ACCION_OPTIONS;
}

export const PAGINATION_SIZES = [10, 25, 50, 100] as const;
